import {ProjectIndicator_project$data} from './__generated__/ProjectIndicator_project.graphql';
function withPrefix(companyProjectId: number | null): string {
	if (!companyProjectId) return '';
	return `P${companyProjectId}`;
}

export type ProjectIndicatorData = {
	workId: string;
	name: string | undefined;
	color: string;
};

export const useProjectIndicatorViewController = (project?: ProjectIndicator_project$data): ProjectIndicatorData | null => {
	if (!project) {
		return null;
	}
	const workId = project.customProjectId ? project.customProjectId : withPrefix(project.companyProjectId);

	return {workId, name: project.name || undefined, color: project.projectColor || ''};
};
